// import { CloudStorageIcon, CreateIcon, HomeIcon } from '../../assets/icons';
import { NavLink } from 'react-router-dom';
import { useAuthContext } from '../../hooks';
import { links } from '../../shared/dataLinks';
import './MobileNavbar.scss';

const MobileNavbar = () => {
  const { user } = useAuthContext();

  return (
    <nav className={`mobile-nav ${!user ? 'small' : ''}`}>
      <ul>
        {links.map((link) =>
          user
            ? link.id < 6 && (
                <li key={link.id}>
                  <NavLink to={link.url}>
                    {link.icon}
                    <span>{link.text}</span>
                  </NavLink>
                </li>
              )
            : !link.isProtected && (
                <li key={link.id}>
                  <NavLink
                    to={link.url}
                    className={link.url === '/auth' ? 'auth-link' : ''}
                  >
                    {link.icon}
                    <span>{link.text}</span>
                  </NavLink>
                </li>
              )
        )}
      </ul>
    </nav>
  );
};

export default MobileNavbar;
